import { FormStore } from "../../stores/FormStore";
import * as React from "react";
import {observer} from "mobx-react";
import {CrudComponent} from "./CrudComponent";
import Form from "../form/Form";
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


@observer
export class CrudFormUserPolling extends CrudComponent {
    id = null;
    formStore: FormStore<any>;
    entity: any;
    showSubmitButton: boolean = true;
    default_role = '';
    defaultRole : any;

    loadMoreData(props: any, module: any) {

    }

    

    load(props: any, module: any) {
        this.id = props.id;
        const formDataClass = module[this.modelName + 'FormData'];
		
        this.formStore = new FormStore<any>(new formDataClass());
		 
        this.formStore.onSubmitCallback = this.postData;
        this.getData();
        this.loadMoreData(props, module);
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await this.api.getDetailAction(this.id).then((data: any) => {
                this.formStore.setData(data);
                this.entity = data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };
     
   // notify = () => toast("Hello", { autoClose: false });
    
    postData = (data: any) => {
        // TODO id optional
		//  console.log("postData-> " , data);
		let isvalidte = false;
         
				return this.api.postFormAction(this.id || '', data).then((response: any) => {
					// toast.success('successful', {autoClose:3000});
					toast.success('Record Saved successfully!');
					isvalidte = true;
					window.location.href = '/login?plu=1'; 
					this.props.onSubmit(response);
		
					
				}).catch((e:any ) => { 
					if(!isvalidte) 
					{  
						 	console.log("errors pol", e.errors.polling_unit_id);
						 	console.log("errors con pas", e.errors.confirm_password);
							
							
							
						// var myerror = e.errors;
						var errorname; 
						if(e.errors.name === undefined) {} else { errorname = e.errors.name[0];}
						var polling_unit_id; 
						if(e.errors.polling_unit_id === undefined) {} else { polling_unit_id = e.errors.polling_unit_id[0];}
						var email; 
						if(e.errors.email === undefined) {} else { email = e.errors.email[0];}
						var phone_number; 
						if(e.errors.phone_number === undefined) {} else { phone_number = e.errors.phone_number[0];}	
						var spassword; 
						if(e.errors.password === undefined) {} else { spassword = e.errors.password[0];}						
						var sconfirm_password; 
						if(e.errors.confirm_password === undefined) {} else { sconfirm_password = e.errors.confirm_password[0];}						
						console.log("errors", errorname);
						console.log("errors poll", polling_unit_id);
						console.log("errors email", email);
						console.log("errors phone", phone_number);
						console.log("errors pass", spassword);
						console.log("errors cof pass", sconfirm_password);
						
						if(errorname != "") toast.error(errorname); 
						if(polling_unit_id != "") toast.error(polling_unit_id); 
						if(sconfirm_password != "") toast.error(sconfirm_password);
						if(phone_number != "") toast.error(phone_number); 
						if(email != "") toast.error(email); 
						if(spassword != "") toast.error(spassword); 
						if(sconfirm_password != "") toast.error(sconfirm_password);
						
						//if(errorname != "") toast.error(errorname); 
						/*else if(polling_unit_id != "") toast.error(polling_unit_id); 
						else if(email != "") toast.error(email); 
						else if(phone_number != "") toast.error(phone_number); 
						else if(password != "") toast.error(password); 
						else if(confirm_password != "") toast.error(confirm_password); */
						
						
					} 
				} ); 
				 
			 
		 
		
		
    };

    render() {
        if (this.isLoading) {
            return <div>Loading ...</div>;
        }

        const fields = this['renderFields'] && this['renderFields']();

        return (
            <Form store={this.formStore} showSubmitButton={this.showSubmitButton}>
                {fields}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudFormUserPolling.tsx